"use client";

import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface DematButtonProps {
  openDematButtonText?: string;
  onClick?: () => void;
  showArrow?: boolean;
  className?: string;
}

const OpenDematButton: FC<DematButtonProps> = ({
  openDematButtonText,
  onClick,
  showArrow = true,
  className,
}) => {
  if (!openDematButtonText) return null;

  const baseClasses =
    "demat-button h-[40px] cursor-pointer rounded-[20px]  bg-[linear-gradient(to_right,_#ff6700_67%,_#ff8900)] p-[12px] text-sm text-white font-medium";
  const widthClass = showArrow ? "w-max" : "min-w-[206px]";

  return (
    <button
      onClick={onClick}
      className={twMerge(baseClasses, widthClass, className)}
      type="button"
    >
      <div className="flex items-center gap-1">
        <span>{openDematButtonText}</span>
        {showArrow && (
          <div className="flex">
            <i
              className="icomoon animated-button text-sm before:content-['\e911']"
              style={{ animationDelay: "0s" }}
            />
            <i
              className="icomoon animated-button text-sm before:content-['\e911']"
              style={{ animationDelay: "0.2s" }}
            />
            <i
              className="icomoon animated-button text-sm before:content-['\e911']"
              style={{ animationDelay: "0.4s" }}
            />
          </div>
        )}
      </div>
    </button>
  );
};

export default OpenDematButton;
